import { Directive, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FiOnboardingReportHelperService } from '../services/fi-onboarding-report-helper.service';
import { FiOnboardingReportService } from '../services/fi-onboarding-report.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {
    IOnboardingReportAvailableItems,
    IOnboardingReportWidget,
    IOnboardingReportWidgetFilter,
} from '../fi-onboarding-report';
import { FiOnboardingReportDateService } from '../services/fi-onboarding-report-date.service';
import { FiOnboardingReportType } from '../fi-onboarding-report-enums';
import { IReportAvailableItemsByData } from '@fi-shared/fi-report-table-filter/fi-report-filter-base';
import { FiOnboardingReportTableFilterHelperService } from '@fi-app/fi-onboarding/fi-onboarding-report/shared/fi-onboarding-report-table-filter-helper.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Directive()
export abstract class FiOnboardingReportDetailsBase implements OnInit, OnDestroy {
    @Input({ required: true }) widget: IOnboardingReportWidget;
    @Input({ required: true }) currentFilter: IOnboardingReportWidgetFilter;
    @Input({ required: true }) selectedFilterItemsChanged$: Observable<void>;
    @Input({ required: true }) availableItems: IOnboardingReportAvailableItems;
    @Input() isSingleTableLayout: boolean = false;
    @Output() availableItemsByDataChange = new EventEmitter<IReportAvailableItemsByData>();

    protected readonly fiOnboardingReportHelperService = inject(FiOnboardingReportHelperService);
    protected readonly fiOnboardingReportService = inject(FiOnboardingReportService);
    protected readonly fiOnboardingReportDateService = inject(FiOnboardingReportDateService);
    protected readonly fiOnboardingReportTableFilterHelperService = inject(FiOnboardingReportTableFilterHelperService);
    protected readonly fiCustomerDataService = inject(FiCustomerDataService);

    protected abstract loadReportData(): void;
    protected searchText: string;

    public ngOnInit(): void {
        this.subscribeOnFilterItemsChange();
        this.subscribeOnDateRangeChanged();
        this.loadReportData();
    }

    protected showSearchField() {
        return this.fiCustomerDataService.isStaging();
    }

    private subscribeOnFilterItemsChange(): void {
        this.selectedFilterItemsChanged$.pipe(debounceTime(500), takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.loadReportData();
        });
    }

    private subscribeOnDateRangeChanged(): void {
        // relevant only for participants onboarded report
        if (this.widget.ReportType !== FiOnboardingReportType.ParticipantsOnboarded) {
            return;
        }
        this.fiOnboardingReportDateService.subscribeOnDateRangeChanged(this.widget.Id, this.ngOnDestroy$, () => {
            this.loadReportData();
        });
    }
    protected ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
